import React from 'react';
import PropTypes from 'prop-types';

const Image = (props) => {
  const { alt, src } = (props.contentState && props.entityKey) ? props.contentState.getEntity(props.entityKey).getData() :
  "" ;
  
  return (
    <span data-offset-key={props.offsetKey}>
      <img src={src} alt={alt} className="rich-text-editor__image" />
      <span> </span>
    </span>
  );
};

Image.propTypes = {
  contentState: PropTypes.object,
  entityKey: PropTypes.string
}


const Link = (props) => {
  const {url} = (props.contentState && props.entityKey) ?
    props.contentState.getEntity(props.entityKey).getData()
    : "";
  
  return (
    <a href={url} className="rich-text-editor__link">
      {props.children}
    </a>
  );
};

Link.propTypes = {
  children: PropTypes.any.isRequired,
  contentState: PropTypes.object,
  entityKey: PropTypes.string
}

export { Image, Link }


// WEBPACK FOOTER //
// ./src/shared/components/presentation/rich-text-editor/entities/Entities.js